import {computed} from 'vue';
import {useLocalePrefix} from '#imports';
import {useBaseUrl} from '~/composables/useBaseUrl';

export function useLinksFrom(origin: string) {
    const baseUrl = useBaseUrl();
    const {withLocalePrefix} = useLocalePrefix();

    // TODO: use NuxtLink to navigate inside the app
    const urlToAdvancedSearch = computed(() =>
        withLocalePrefix(
            baseUrl.resolve({
                path: '/s/advanced',
                query: {
                    brief_origin: origin,
                },
            }),
        ),
    );

    return {
        urlToAdvancedSearch,
    };
}
